import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { CrmAgendorComponent } from './crm-agendor/crm-agendor.component';
import { CrmPipedriveComponent } from './crm-pipedrive/crm-pipedrive.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    CrmPipedriveComponent,
    CrmAgendorComponent,
  ],
  exports: [
    CrmPipedriveComponent,
    CrmAgendorComponent,
  ],
  providers: [
  ]
})

export class CrmAttendanceModule { }
